import { defineMessages } from 'react-intl';

export default defineMessages({
  formTitle: {
    id: 'id_memp.title',
  },
  formSubTitle: {
    id: 'login_recovery.insert_infos_subTitle',
  },
  title: {
    id: 'id_memp.title',
  },
  subTitle: {
    id: 'id_memo.title',
  },
  memoId: {
    id: 'id_memo.memo_id',
  },
  iWantToSaveMyId: {
    id: 'id_memo.i_want_to_save_my_id',
  },
  inMyAddressMail: {
    id: 'id_memo.in_my_address_mail',
  },
  email: {
    id: 'id_memo.email',
  },
  iAccept: {
    id: 'id_memo.i_accept',
  },
  termsAndConditions: {
    id: 'id_memo.terms_and_conditions',
  },
  personalData: {
    id: 'id_memo.personal_data',
  },
  emailInputError: {
    id: 'signup_personal_info.email.error',
  },
  requiredField: {
    id: 'required.field',
  },
  modalTitle: {
    id: 'modal.Title',
  },
  close: {
    id: 'modal.close',
  },
  accept: {
    id: 'modal.accept',
  },
  conditionsGeneralError: {
    id: 'signup_personal_info.accept_conditions_utilisateur_error',
  },
  confirm: {
    id: 'login_recovery.confirmer',
  },
});
